<template>
    <div class="wells-sub-header">
        <treatment-view-mode-select />

        <video-controls-panel v-if="showVideoControls" />

        <div
            v-if="tenant.settings.showCycleDetails && isWellCardView && !isFdaFriendly"
            class="treatment-details"
            :class="{
                'move-text': cycleDetailsAreVisible
            }"
            @click="toggleTreatmentFilter"
        >
            {{ $translate('treatment_details') }}
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { TREATMENT_PAGE_VIEWS } from '../../business/const'
import Utils from '../../business/utils/Utils'
import TreatmentViewModeSelect from './partials/TreatmentViewModeSelect'
import VideoControlsPanel from './partials/VideoControlsPanel'

export default {
    name: 'WellsSubHeader',
    components: {
        VideoControlsPanel,
        TreatmentViewModeSelect
    },
    computed: {
        ...mapState({
            currentView: state => state.navigation.currentView,
            cycleDetailsAreVisible: state => state.filter.cycleDetailsAreVisible
        }),
        ...mapGetters({
            isFdaFriendly: 'common/isFdaFriendly',
            tenant: 'common/getTenant',
            isTooEarlyForScores: 'timelapse/isTooEarlyForScores'
        }),
        showVideoControls() {
            const { WELL_CARDS, COMPARE_WELLS } = TREATMENT_PAGE_VIEWS
            const isCardsOrCompare = [WELL_CARDS, COMPARE_WELLS].includes(this.currentView)

            return !Utils.isMobileSize() && isCardsOrCompare
        },
        isWellCardView() {
            return this.currentView === TREATMENT_PAGE_VIEWS.WELL_CARDS
        }
    },
    methods: {
        toggleTreatmentFilter() {
            this.$store.commit('filter/setCycleDetailsVisibility', !this.cycleDetailsAreVisible)
        }
    }
}
</script>

<style lang="scss" scoped>
.wells-sub-header {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: $wells-sub-header-height;
    @include prevent-select();
    z-index: 23;

    .video-controls-panel {
        width: 70%;
    }
    .treatment-details {
        position: fixed;
        right: 1rem;
        color: $blue;
        cursor: pointer;
        transition: 0.5s;

        &.move-text {
            top: 7.7rem;
            margin-right: 9.5rem;
            transition: 0.5s;
        }
        @media screen and #{$new-break4close} {
            display: none;
        }
    }
    @media screen and #{$new-break3close} {
        .video-controls-panel {
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            height: $well-video-controls-bottom-panel-height;
        }
    }

    @media print {
        display: none;
    }
}
</style>
